module.exports = __webpack_public_path__ + "static/media/nophoto.d1e70f57.png";